var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8167 13.6667C6.46737 13.6667 6.11937 13.5307 5.85804 13.26L0.707371 7.92667C0.203371 7.40267 0.210037 6.57201 0.724704 6.05734L6.05804 0.724008C6.57804 0.202674 7.42204 0.202674 7.94337 0.724008C8.46337 1.24534 8.46337 2.08801 7.94337 2.60934L3.5367 7.01601L7.77537 11.4067C8.28737 11.9373 8.2727 12.7813 7.74337 13.292C7.48337 13.5427 7.15004 13.6667 6.8167 13.6667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.ff83d0c2.svg";
export { ForwardRef as ReactComponent };